import jQuery from "jquery";
import {getLocation} from "../services/locationService";

jQuery.widget('ep.posSearchWidget', {
    options: {
        searchPath: undefined,
        searchExtraData: {},
        locationSearchPath: undefined,
        locationSearchExtraData: {},
        classes: {
            resultsWithHeadlines: 'with-headlines',
            resultHeadline: 'store-finder-result-headline',
            resultHeadlineByName: 'by-name',
            resultHeadlineByLocation: 'by-location',
            resultsNoHeadlines: 'no-headlines',
            resultsHidden: 'pos-search__results-container--hidden',
            open: 'post-code-module-component--open',
            bodyOpen: 'dialog-open',
            searching: 'post-code-module-component--searching',
            validationError: 'post-code-module-component--validation-error',
            validationLocationError: 'post-code-module-component--validation-location-error',
        },
        selectors: {
            form: '.pos-search-widget__form',
            input: '.pos-search-widget-query',
            locationBtn: '.pos-search-widget__location-btn',
            searchBtn: '.pos-search-widget-query__submit',
            ctaSearchBtn: '.post-code-module-component__cta-search-btn',
            lookupConfirmBtn: '.post-code-module-component__lookup-confirm',
            validationHolder: '.post-code-module-component__search-input-validation',
            locationErrorOutput: '.post-code-module-component__search-location-validation',
            isStartOnLoad: '.post-code-module-component__start-on-load',
            toggleVisibilityElement: '[data-show-post-code-module-component]',
            resultsContainer: '.pos-search__results-wrapper',
        },
        selectorsToDisable: ['form', 'input', 'locationBtn', 'searchBtn', 'ctaSearchBtn'],
        texts: {
            validationError: __('postalcodemodule.validationFailed'),
            validationLocationError: __('postalcodemodule.validationLocationFailed')
        },
        showOnLoad: false,
    },
    _create: function () {
        const locationBtn = this.element.find(this.options.selectors.locationBtn);
        this._on(locationBtn, {
            click: 'locationSearch'
        });

        this._createDomCache();

        const form = this.element.find(this.options.selectors.form);
        this._on(form, {
            submit: (event) => {
                event.preventDefault();

                this.search();
            }
        });

        this.element.find(this.options.selectors.validationHolder).append(this.options.texts.validationError);
        this.element.find(this.options.selectors.locationErrorOutput).append(this.options.texts.validationLocationError);
    },
    search: function () {
        if (!this._isSearching()) {
            const widget = this;

            this._onStartSearch();

            const element = this.element;
            const options = this.options;

            const input = element.find(options.selectors.input);

            const requestData = jQuery.extend({
                searchText: input.val()
            }, options.searchExtraData);

            jQuery.ajax({
                dataType: 'json',
                url: options.searchPath,
                data: requestData
            }).then(function (data) {
                widget._showQueryResultsOverlay(data, true);
            }).always(function () {
                widget._onEndSearch();
            });
        }
    },
    _createDomCache: function () {
        const element = this.element;

        this._domCache = {
            resultsContainer: element.find('.pos-search__results-container'),
            resultsWrapper: element.find('.pos-search__results-wrapper'),
            storeFinderQueryInput: element.find('.pos-search-widget-query'),
        };
    },
    _showQueryResultsOverlay: function (stores, showHeadlines) {
        const widget = this;
        const classes = widget.options.classes;

        const resultsWrapper = this._domCache.resultsWrapper;
        resultsWrapper.removeClass(classes.resultsWithHeadlines);
        resultsWrapper.children().remove();

        const resultsContainer = this._domCache.resultsContainer;
        resultsContainer.removeClass(classes.resultsHidden);

        if (stores.length === 0) {
            const emptyElm = jQuery('<div/>');
            emptyElm.addClass('store-finder-result-empty');
            emptyElm.text(__('storefindercomponent.emptyresults.message'));

            this._domCache.resultsWrapper.append(emptyElm);
        } else {
            const storesByLocation = [];

            jQuery.each(stores, function (idx, store) {
                const storeElm = widget._createStoreElm.apply(widget, [store, location]);
                storesByLocation.push(storeElm);
            });

            if (showHeadlines) {
                //Show titles
                resultsWrapper.addClass(classes.resultsWithHeadlines);

                if (storesByLocation.length !== 0) {
                    const storesByLocationWrapper = jQuery('<div/>');
                    if (showHeadlines) {
                        const placeOrStoreElm = jQuery('<div/>');
                        placeOrStoreElm.text(__('pos-search-widget.result') + '\u201e' + widget._domCache.storeFinderQueryInput.val() + '\u201d' + ':');
                        placeOrStoreElm.addClass(classes.resultHeadline);
                        placeOrStoreElm.addClass(classes.resultHeadlineByLocation);

                        storesByLocationWrapper.append(placeOrStoreElm);
                    }

                    storesByLocationWrapper.append(storesByLocation);
                    resultsWrapper.append(storesByLocationWrapper);
                }
            } else {
                resultsWrapper.addClass(classes.resultsNoHeadlines);
                resultsWrapper.append(storesByLocation);
            }
        }
    },
    _createStoreElm: function (store) {
        const storeElm = jQuery('<div/>');
        storeElm.addClass('store-finder-result');

        //Place or Store
        storeElm.addClass('store-finder-result-place');

        //Code result
        var storeLogo = jQuery('<span/>');

        storeLogo.text(store.displayName + ',' + ' ' + store.address.postalCode + ' ' + store.address.town);
        storeLogo.addClass('merchantstore-result-pos-name');
        const serviceCode = this.element.data('pagelabel');

        const storeLogoLink = jQuery('<a/>');
        storeLogoLink.attr('href', '/' + store.urlName + '/' + serviceCode);
        storeLogoLink.attr('alt', store.name);

        storeLogoLink.append(storeLogo);
        storeElm.append(storeLogoLink);

        return storeElm;
    },
    locationSearch: function () {
        if (!this._isSearching()) {
            this._onStartSearch();

            const element = this.element;
            const options = this.options;
            const widget = this;

            getLocation()
                .then(function (location) {
                    const url = options.locationSearchPath;
                    const requestData = jQuery.extend({
                        lat: location.lat,
                        long: location.lng,
                    }, options.locationSearchExtraData);

                    return jQuery.ajax({
                        dataType: 'json',
                        url: url,
                        data: requestData,
                    }).then(function (data) {
                        widget._showQueryResultsOverlay(data, false)
                    });
                }, function (err) {
                    const validationErrorClass = options.classes.validationLocationError;
                    element.addClass(validationErrorClass);
                })
                .always(function () {
                    widget._onEndSearch()
                });
        }
    },
    _isSearching: function () {
        const searchingClass = this.options.classes.searching;
        return this.element.hasClass(searchingClass);
    },
    _onStartSearch: function () {
        const classes = this.options.classes;
        const searchingClass = classes.searching;
        const validationErrorClass = classes.validationError;
        const validationLocationErrorClass = classes.validationLocationError;

        this.element.addClass(searchingClass);
        this.element.removeClass(validationErrorClass);
        this.element.removeClass(validationLocationErrorClass);

        this._toggleDisableElements(true);
    },
    _onEndSearch: function () {
        const searchingClass = this.options.classes.searching;
        this.element.removeClass(searchingClass);

        this._toggleDisableElements(false);
    },
    _toggleDisableElements: function (disable) {
        const selectors = this.options.selectors;

        this.options.selectorsToDisable.forEach((selectorToDisable) => {
            const selector = selectors[selectorToDisable];
            this.element.find(selector).prop('disabled', disable);
        });
    }
});

export default function () {
    // Nothing to initialize
}
